import * as React from 'react';
import { connect } from 'react-redux';
import { Production } from '../classes/production';

export interface ExternalProps {
    production: Production;
}

export class ProductionComponent extends React.Component<ExternalProps, null> {
    constructor(props: ExternalProps) {
        super(props);
    }

    render() {
        return (
            <div className="item full-carousel-item swiper-slide swiper-slide-next">
                <div className="full-carousel-item-img-container">
                    <img src={this.props.production.productionImageUrl} title={this.props.production.productionTitle} className="full-carousel-item-img" />
                    <p className="full-carousel-item-img-date">{this.props.production.time}</p>
                </div>
                <p className="full-carousel-item-subheading">{this.props.production.productionPreTitle}</p>
                <p className="full-carousel-item-heading un-button">{this.props.production.productionTitle}</p>
                <p className="full-carousel-item-time" dangerouslySetInnerHTML={{ __html: this.props.production.productionSubtitle }}></p>
                <a href={this.props.production.pdpUrl} className="full-carousel-item-cta button">{this.props.production.ctaButtonText}</a>
            </div>
            
        );
    }
}

export default connect(null, null)(ProductionComponent);